export { default } from './counter-compact';
